import React from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router";
import { getCurrentAttempt } from "selectors";
import { Attempt, ReduxState } from "types";

export const useCurrentAttempt = (platformIdFromProps?: string) => {
  const { meetId, platformId } = useParams<{
    meetId: string;
    platformId: string;
  }>();

  const props = React.useMemo(() => {
    return {
      match: {
        params: {
          meetId,
          platformId: platformIdFromProps ?? platformId,
        },
      },
    };
  }, [meetId, platformId, platformIdFromProps]);

  const currentAttempt = useSelector((state: ReduxState) =>
    getCurrentAttempt(state, props)
  ) as Attempt;

  return currentAttempt;
};
